import React from 'react';
import { Modal } from 'antd';
import ListProduct from 'components/PurchaseOrder/ListProduct';
import { X } from '@phosphor-icons/react';
import { InventoryDocumentItem } from 'models';
import { SaleOrderItem } from 'models/SaleOrder';
import ListSaleProduct from '../Panel/ListSaleProduct';

const QuickViewProductsModal: React.FC<{
  isOpen: boolean;
  onClose: () => void;
  products: InventoryDocumentItem[] | SaleOrderItem[];
  customButton?: React.ReactNode;
  typeOrder?: 'InventoryDocuments' | 'SaleOrders';
}> = ({ isOpen, onClose, products, customButton, typeOrder = 'InventoryDocuments' }) => {
  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width={1400}
      className='modal-none-padding'
      closeIcon={<X size={28} color='var(--textBlack)' />}
      maskClosable={false}
      centered
    >
      <div className='bg-white rounded-lg'>
        <div className='px-6 py-3'>
          <h2 className='text-2xl font-bold'>DANH SÁCH SẢN PHẨM</h2>
          <p className='text-[var(--textGray)] text-sm mt-2'>
            Tất cả các danh sách trong đơn hàng đều được hiển thị tại đây
          </p>
        </div>

        <div className='mt-2 rounded-b-lg overflow-hidden'>
          <div className='max-h-[80vh] overflow-y-auto'>
            {typeOrder === 'InventoryDocuments' ? (
              <ListProduct
                products={products as InventoryDocumentItem[]}
                emptyText='Không có sản phẩm nào trong đơn hàng'
                isQuickView={true}
              />
            ) : (
              <ListSaleProduct
                products={products as SaleOrderItem[]}
                emptyText='Không có sản phẩm nào trong đơn hàng'
                isQuickView={true}
              />
            )}
          </div>
        </div>
        <div className='bg-[var(--bgGreyColor)] rounded-b-lg flex justify-center items-center py-2 gap-2'>
          {customButton}
        </div>
      </div>
    </Modal>
  );
};

export default QuickViewProductsModal;
